import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import AdminPage from "./index"


export const VtAdminRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.ADMIN_PATH,
	title: VISIBILITY_TRACKER_ROUTES.ADMIN_TITLE,
	icon: 'sliders',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Manage retailers, sections and daily assignments',
	access: USER_ROLE.ADMIN,
	children: [{
		element: <AdminPage />,
		index: true
	}]
}
